export type ExampleApiTypeCard = {
  id: number;
};

export type FetchStatus = 'idle' | 'loading' | 'success' | 'failed';

export type Meta = {
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
};

export type Document = {
  id: number;
  original_name: string;
  uploaded_by: {
    email: string;
    full_name: string;
    id: number;
    role: UserRole;
  };
  created_at: string;
  is_processed: boolean;
  category: null | DocumentCategory;
  department: null | Omit<DocumentCategory, 'created_at'>;
};

export type DocumentResponse = Meta & {
  results: Document[];
};

export type DocumentCategory = {
  id: number;
  name: string;
  created_at: string;
};

export interface CompanyData {
  name: string;
  website_link: string;
  industry: string;
  employees_num: string;
  mission: string;
}

export interface Member {
  name: string;
  email: string;
  role: string;
  position: string;
}

export interface AddedMember {
  id: number;
  email: string;
  invite_uuid: string;
  full_name: string;
  role: UserRole;
  position: string;
  last_activity?: string | null;
  created_at?: string;
}

export enum UserRole {
  SA = 'SA',
  MEM = 'MEM',
  MAN = 'MAN',
}

interface User {
  id: number;
  email: string;
  image_url: string;
  role: UserRole;
  position: string;
  assistant_name: string;
  gender: string;
  communication_style: string;
  full_name: string;
  company: number | null;
}

export interface QAItem {
  id: number;
  question: string;
  answer: string;
  department: {
    id: number;
    name: string;
    created_at: string;
  } | null;
  category: {
    id: number;
    name: string;
    created_at: string;
  };
  created_at: string;
  updated_at: string;
}

export interface CompanyRegisterData {
  name: string;
  website_link: string;
  industry: string;
  employees_num: number;
  mission: string;
}

export interface UserByRequests {
  id: number;
  count: number;
  full_name: string;
}

export interface RequestByDate {
  date: string;
  count: number;
}
